const tokenomicsShellStyle = {
  backgroundImage: "url(/assets/bg.png)",
};

export default tokenomicsShellStyle;
